import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PrescriptionUploadDialogData {
  orderId: number;
  acceptFiles: string;
}

@Component({
  selector: 'app-prescription-upload-dialog',
  templateUrl: './prescription-upload-dialog.component.html',
  styleUrls: ['./prescription-upload-dialog.component.scss'],
  standalone: false,
})
export class PrescriptionUploadDialogComponent {
  constructor(
    private _dialogRef: MatDialogRef<PrescriptionUploadDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: PrescriptionUploadDialogData
  ) {}

  onUploadComplete(success: boolean): void {
    if (success) {
      this._dialogRef.close(true);
    }
  }
}
